import { render, staticRenderFns } from "./MiniProgramRuiShiLiGouWuOrderProduct.vue?vue&type=template&id=c23f3a14&scoped=true&"
import script from "./MiniProgramRuiShiLiGouWuOrderProduct.vue?vue&type=script&lang=js&"
export * from "./MiniProgramRuiShiLiGouWuOrderProduct.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramRuiShiLiGouWuOrderProduct.vue?vue&type=style&index=0&id=c23f3a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f3a14",
  null
  
)

export default component.exports